module.exports = __webpack_public_path__ + "img/AT0000002592176.4d12419a.png";